import { EditorState } from 'draft-js';
import modifyBlockForContentState from 'draft-js/lib/modifyBlockForContentState';

var modifyBlock = function modifyBlock(editorState, blockData) {
  var content = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var newContent = modifyBlockForContentState(content, selection, function (block) {
    return block.merge(blockData);
  });

  return EditorState.push(editorState, newContent, 'split-block' // TODO: will this do ?
  );
};

export default modifyBlock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/modifyBlock.js
// module id = 249
// module chunks = 0